import { useTranslation } from 'react-i18next'
import { motion, useReducedMotion } from 'framer-motion'
import { Instagram } from 'lucide-react'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { cn } from '@/lib/utils'

export function KitchenSection() {
  const { t } = useTranslation('home')
  const shouldReduceMotion = useReducedMotion()

  const fadeUp = shouldReduceMotion
    ? {}
    : {
        initial: { opacity: 0, y: 24 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true, margin: '-80px' },
        transition: { duration: 0.6, ease: 'easeOut' as const },
      }

  return (
    <section
      className="bg-cream px-4 py-[clamp(4rem,10vw,8rem)] sm:px-6 lg:px-8"
      aria-labelledby="kitchen-heading"
    >
      <div className="mx-auto max-w-7xl">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          {/* Text */}
          <motion.div {...fadeUp} className="order-2 lg:order-1">
            <img
              src="/media/logo-cucina.jpg"
              alt={t('kitchen.logoAlt')}
              className={cn(
                'mb-6 h-20 w-auto rounded-2xl shadow-md sm:h-24',
                !shouldReduceMotion && '-rotate-3'
              )}
              loading="lazy"
            />
            <SectionHeading
              id="kitchen-heading"
              align="left"
              title={t('kitchen.title')}
              description={t('kitchen.description')}
              className="mx-0 max-w-none text-left"
            />
            <a
              href="https://www.instagram.com/lacucinadelmaia/"
              target="_blank"
              rel="noopener noreferrer"
              className={cn(
                'mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3',
                'text-sm font-semibold text-white transition-colors hover:bg-stone',
                'focus-visible:ring-2 focus-visible:ring-ink focus-visible:ring-offset-2'
              )}
            >
              <Instagram className="h-4 w-4" aria-hidden="true" />
              {t('kitchen.cta')}
            </a>
          </motion.div>

          {/* Chefs photo */}
          <motion.div
            {...fadeUp}
            className="order-1 lg:order-2"
            transition={{ ...fadeUp.transition, delay: 0.15 }}
          >
            <div
              className={cn(
                'relative overflow-hidden rounded-2xl bg-white p-3 shadow-lg',
                !shouldReduceMotion && 'rotate-1'
              )}
            >
              <img
                src="/media/maia-cucina.jpg"
                alt={t('kitchen.imageAlt')}
                className="aspect-square w-full rounded-xl object-cover"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
